module.exports = __webpack_public_path__ + "media/img/partners/kantipur-logo-de096e10e042c2deaf4323a6d014fbe3.png";